import { render, staticRenderFns } from "./CarPartsList.vue?vue&type=template&id=d18d9138&"
import script from "./CarPartsList.vue?vue&type=script&lang=js&"
export * from "./CarPartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports